/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'transfer': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 10)" _stroke="#00272E"><polyline pid="0" points="4.33333333 0 0 4 12 4"/><polyline pid="1" points="12.6666667 13 17 9 5 9"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/transfer.js